import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=218a30e3"
import script from "./MainNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavbar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports